export const GiftEndpoints = {
    donate: () => '/gift/donate',
    addCard: () => '/gift/wallet/add',
};
